import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    solutions: [
      { id: 'footer_support', label: 'IT Support', href: '/services#support' },
      { id: 'footer_cloud', label: 'Cloud Services', href: '/services#cloud' },
      { id: 'footer_security', label: 'Cybersecurity', href: '/services#security' },
      { id: 'footer_dev', label: 'Software Dev', href: '/services#development' },
    ],
    company: [
      { id: 'footer_about', label: 'About Us', href: '/about' },
      { id: 'footer_portfolio', label: 'Portfolio', href: '/portfolio' },
      { id: 'footer_contact', label: 'Contact', href: '/contact' },
    ],
    resources: [
      { id: 'footer_support_res', label: 'Support', href: '/contact' },
    ],
  };

  const socialLinks = [
    { id: 'social_linkedin', icon: 'UserGroupIcon', href: '#', label: 'LinkedIn' },
    { id: 'social_twitter', icon: 'ChatBubbleLeftRightIcon', href: '#', label: 'Twitter' },
    { id: 'social_github', icon: 'CodeBracketIcon', href: '#', label: 'GitHub' },
  ];

  return (
    <footer className="bg-gray-950 border-t border-zinc-800 py-16">
      <div className="container mx-auto px-6 max-w-7xl">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12 mb-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <div className="mb-4">
              <span className="text-xl font-bold text-white">E-GREGOR</span>
            </div>
            <p className="text-sm text-gray-400 mb-6 leading-relaxed">
              Comprehensive technology solutions for businesses. From web design to cybersecurity.
            </p>
            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.id}
                  href={social.href}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-blue-500 hover:text-white transition-colors duration-200"
                  aria-label={social.label}
                >
                  <Icon name={social.icon as any} size={20} />
                </a>
              ))}
            </div>
          </div>

          {/* Solutions Column */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Solutions
            </h4>
            <ul className="space-y-3">
              {footerLinks.solutions.map((link) => (
                <li key={link.id}>
                  <Link
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Company
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.id}>
                  <Link
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Column */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Resources
            </h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.id}>
                  <Link
                    href={link.href}
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © {currentYear} E-GREGOR GROUP LTD. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            <Link
              href="/privacy-policy"
              className="text-sm text-gray-500 hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms-conditions"
              className="text-sm text-gray-500 hover:text-white transition-colors"
            >
              Terms &amp; Conditions
            </Link>
            <Link
              href="/cookie-policy"
              className="text-sm text-gray-500 hover:text-white transition-colors"
            >
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}